import React from "react";

import { Pill, PillVariants } from "src/base-components/Pill";
import { AccessRequestStatus } from "src/clients/taktile-api";

const STATUS_PILL_VARIANT: Record<AccessRequestStatus, PillVariants> = {
  [AccessRequestStatus.PENDING]: "orange",
  [AccessRequestStatus.APPROVED]: "green",
  [AccessRequestStatus.REJECTED]: "red",
  [AccessRequestStatus.CANCELLED]: "gray",
};

export const AccessRequestStatusPill: React.FC<{
  status: AccessRequestStatus;
}> = ({ status }) => (
  <Pill variant={STATUS_PILL_VARIANT[status]}>
    <Pill.Text>{status}</Pill.Text>
  </Pill>
);
